import { WParagraphFormat } from './paragraph-format';
import { WCharacterFormat } from './character-format';
import { HelperMethods } from '../editor/editor-helper';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * @private
 */
export class WStyle {
}
/**
 * @private
 */
export class WParagraphStyle extends WStyle {
    constructor(node) {
        super();
        this.ownerBase = node;
        this.paragraphFormat = new WParagraphFormat(this);
        this.characterFormat = new WCharacterFormat(this);
    }
    /**
     * @private
     * @returns {void}
     */
    clear() {
        if (this.characterFormat) {
            this.characterFormat.clearFormat();
        }
        if (this.paragraphFormat) {
            this.paragraphFormat.clearFormat();
        }
    }
    /**
     * Disposes the internal objects which are maintained.
     *
     * @private
     * @returns {void}
     */
    destroy() {
        if (this.characterFormat) {
            this.characterFormat.destroy();
            this.characterFormat = undefined;
        }
        if (this.paragraphFormat) {
            this.paragraphFormat.destroy();
            this.paragraphFormat = undefined;
        }
        this.ownerBase = undefined;
        this.name = undefined;
        this.next = undefined;
        this.basedOn = undefined;
        this.link = undefined;
    }
    copyStyle(paraStyle) {
        this.name = paraStyle.name;
        this.ownerBase = paraStyle.ownerBase;
        this.type = paraStyle.type;
        this.next = paraStyle.next;
        this.basedOn = paraStyle.basedOn;
        this.link = paraStyle.link;
        this.characterFormat.copyFormat(paraStyle.characterFormat);
        this.paragraphFormat.copyFormat(paraStyle.paragraphFormat);
    }
}
/**
 * @private
 */
export class WCharacterStyle extends WStyle {
    constructor(node) {
        super();
        this.ownerBase = node;
        this.characterFormat = new WCharacterFormat(this);
    }
    /**
     * @private
     * @returns {void}
     */
    clear() {
        if (this.characterFormat) {
            this.characterFormat.clearFormat();
        }
    }
    /**
     * Disposes the internal objects which are maintained.
     *
     * @private
     * @returns {void}
     */
    destroy() {
        if (this.characterFormat) {
            this.characterFormat.destroy();
            this.characterFormat = undefined;
        }
        this.ownerBase = undefined;
        this.name = undefined;
        this.next = undefined;
        this.basedOn = undefined;
        this.link = undefined;
    }
    copyStyle(charStyle) {
        this.name = charStyle.name;
        this.ownerBase = charStyle.ownerBase;
        this.type = charStyle.type;
        this.next = charStyle.next;
        this.basedOn = charStyle.basedOn;
        this.characterFormat.copyFormat(charStyle.characterFormat);
    }
}
/**
 * @private
 */
export class WTableStyle extends WStyle {
    constructor(node) {
        super();
        this.ownerBase = node;
    }
    /**
     * Disposes the internal objects which are maintained.
     *
     * @private
     * @returns {void}
     */
    destroy() {
        this.ownerBase = undefined;
        this.name = undefined;
        this.next = undefined;
        this.basedOn = undefined;
        this.link = undefined;
    }
}
/**
 * @private
 */
export class WStyles {
    constructor() {
        this.collection = [];
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }
    get length() {
        return this.collection.length;
    }
    remove(item) {
        this.collection = this.collection.filter((a) => (a.name !== item.name));
    }
    push(item) {
        if (item != null && item !== undefined) {
            this.collection.push(item);
        }
        return 1;
    }
    getItem(index) {
        if (this.collection.length > index) {
            return this.collection[parseInt(index.toString(), 10)];
        }
        return null;
    }
    indexOf(item) {
        return this.collection.indexOf(item);
    }
    contains(item) {
        const index = this.collection.indexOf(item);
        return index > -1 && index < this.collection.length;
    }
    clear() {
        if (this.collection && this.collection.length > 0) {
            for (let i = 0; i < this.collection.length; i++) {
                const style = this.collection[parseInt(i.toString(), 10)];
                if (style instanceof WCharacterStyle) {
                    style.clear();
                }
                else if (style instanceof WParagraphStyle) {
                    style.clear();
                }
            }
        }
        this.collection = [];
    }
    findByName(name, type) {
        let returnStyle;
        for (const value of this.collection) {
            if (value.name === name) {
                returnStyle = value;
                if (!isNullOrUndefined(type)) {
                    if (value.type !== type) {
                        returnStyle = undefined;
                    }
                }
            }
        }
        return returnStyle;
    }
    getStyleNames(type) {
        return this.collection.filter((a) => (a.type === type)).map((a) => {
            return a.name;
        });
    }
    /* eslint-disable @typescript-eslint/no-explicit-any */
    getStyles(type) {
        const styles = this.collection.filter((a) => (a.type === type)).map((a) => {
            return a;
        });
        const styleObjects = [];
        for (const style of styles) {
            const returnStyle = {};
            const returnStyleObject = {};
            if (type === 'Paragraph') {
                returnStyleObject.paragraphFormat = {};
                HelperMethods.writeParagraphFormat(returnStyleObject.paragraphFormat, true, style.paragraphFormat);
            }
            if (type !== 'Table') {
                returnStyleObject.characterFormat = {};
                HelperMethods.writeCharacterFormat(returnStyleObject.characterFormat, true, style.characterFormat);
            }
            returnStyle.name = style.name;
            returnStyle.style = JSON.stringify(returnStyleObject);
            if (!isNullOrUndefined(type)) {
                returnStyle.type = type;
                if (returnStyle.type === 'Paragraph' && !isNullOrUndefined(style.link)) {
                    returnStyle.type = 'Linked';
                }
            }
            styleObjects.push(returnStyle);
        }
        return styleObjects;
    }
    /**
     * Disposes the internal objects which are maintained.
     *
     * @private
     * @returns {void}
     */
    destroy() {
        if (this.collection && this.collection.length > 0) {
            for (let i = 0; i < this.collection.length; i++) {
                const style = this.collection[parseInt(i.toString(), 10)];
                if (style instanceof WCharacterStyle) {
                    style.destroy();
                }
                else if (style instanceof WParagraphStyle) {
                    style.destroy();
                }
                else if (style instanceof WTableStyle) {
                    style.destroy();
                }
            }
        }
        this.collection = [];
        this.collection = undefined;
    }
}
